import React from 'react'
import classes from './TruckTypes.module.css'
import SubSectionHeader from '../../Shared/SubSectionHeader'
import NotAvailable from '../NotAvailable'

const TruckTypes = ({TruckTypesList=[]}) => {
    const TruckTypesCard=({truck,index})=>{
        return (
        <li className={classes['listItem']}>{truck.type}</li>
        )
    }
    return (
        <div className={classes['Container']}>
            <SubSectionHeader title="Major Truck Types" className={classes['title']}></SubSectionHeader>
          <div className={classes['TruckContainer']}>
              <ul className={classes['ListContainer']}>
              {
                    TruckTypesList.length>0? TruckTypesList.map((item,index)=><TruckTypesCard truck={item} index={index}/>):
                    <NotAvailable/>

                 }
              </ul>
                
          </div>
        </div>
    )
}

export default TruckTypes
